<template>
  <div>
    <Subtitle v-bind:ServiceID="this.AppServiceID">
      <template v-slot:header>
        <i class="fas fa-bell"></i><b>Notifications:</b>
      </template>
    </Subtitle>
    <div class="col-6 pl-0" v-if="clinic.length > 0">
      <div class="card">
        <div
          class="card-header d-flex align-items-center pl-1"
          style="height: 2rem; text-align: left"
        >
          <h5>
            <small class="text-muted"
              ><b
                ><i class="fas fa-clinic-medical"></i>Clinic:
                {{ clinic[0].pname }}</b
              ></small
            >
          </h5>
        </div>
        <div class="card-body p-2 mb-0">
          <div class="row">
            <span for="cname" class="col-sm-4"><b>Clinic #:</b></span>
            <span class="col-sm-8" type="text">{{ clinic[0].clinicno }}</span>
          </div>
          <div class="row">
            <span for="cname" class="col-sm-4"><b>Address:</b></span>
            <span class="col-sm-8" type="text">{{ clinic[0].address }}</span>
          </div>
          <div class="row">
            <span for="cname" class="col-sm-4"><b>City:</b></span>
            <span class="col-sm-8" type="text">{{ clinic[0].city }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6 pl-0 mt-2" v-if="clinic.length > 0"> 
        <div
          class="card-header d-flex align-items-center pl-1"
          style="height: 2rem; text-align: left"
        >
          <h5>
            <small class="text-muted"
              ><b
                ><i class="fas fa-mail-bulk"></i>Email Notifications:
                 </b
              > Please add up to five emails to get notifications.</small
            >
          </h5>
        
      </div>
    </div>
    <div id="Alloc" class="mt-0 ml-0 pl-0 col-6">
      <form class="card" id="alloc">
        <v-client-table
          :data="tableData"
          :columns="columns"
          :options="options"
          v-model="tableData"
        >
          <div slot="afterBody" class="VueTables_Adduser m-2">
            <button
              type="button"
              v-on:click="submitForm()"
              class="btn btn-primary btn-sml mt-1"
            >
              Save Emails
            </button>
          </div>
          <div
            v-for="column in options.editableColumns"
            :key="column"
            :slot="column"
            slot-scope="{ row, update }"
          >
            <input type="text" v-model="row[column]" @input="update" />
          </div>
        </v-client-table>
      </form>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import LayoutDefault from "@/Common/Default/DefaultLayout.vue";
import Subtitle from "@/Common/Default/SubTitle.vue";
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import { PopUpVariant } from "@/Common/Default/PopUpVariant";
import { isNullOrUndefined } from "util";
import Datepicker from "vuejs-datepicker";
import Vuelidate from "vuelidate";
import { helpers } from "vuelidate/lib/validators";
import {
  required,
  minLength,
  maxLength,
  between,
  withParams,
  numeric,
} from "vuelidate/lib/validators";
const alphaNum = helpers.regex("alphaNum", /^\d{1,5}\s\w*/);
Vue.use(Vuelidate);
export default {
  name: "DentalHome",
  props: { LeadAssessor: false, ServiceID: "" },
  // TODO: This tableData should populate from the database for this pharmacy
  data: function () {
    return {
      validdata: false,
      tableData: [
        { id: 1, label: "Email Address: 1", email: "" },
        { id: 2, label: "Email Address: 2", email: "" },
        { id: 3, label: "Email Address: 3", email: "" },
        { id: 4, label: "Email Address: 4", email: "" },
        { id: 5, label: "Email Address: 5", email: "" },
      ],
      clinic: [],
      ClinicNo: "",
      dateFormat: "",
      TypeHeadinptClass: "form-control",
      datapickClass: "form-control form-control-xs my-0",
      PopUpVar: PopUpVariant,
      Showinfo: false,
      showError: false,
      MsgPopup: false,
      showModal: false,
      columns: ["label", "email"],
      //columns:['text','text2','checkbox'],
      options: {
        editableColumns: ["email"],
        filterable: "",
        sortable: "",
        footerHeadings: false,
        perPage: 5,
        perPageValues: [],
        templates: {},
        headings: {
          email: "Email Address",
          label: "",
        },
        texts: {
          count:''
        }
      },
    };
  },
  watch: {},
  components: {
    Card,
    CardBody,
    TileNote,
    Datepicker,
    Subtitle,
  },
  filters: {
    moment: function (date) {
      return moment(date, "YYYY-MM-DD").format("YYYY/MM/DD");
    },
    stringify(value) {
      return JSON.stringify(value, null, 2);
    },
  },
  computed: {
    UserName() {
      return !this.$store.getters.GetCurrentUser
        ? false
        : this.$store.getters.GetCurrentUser;
    },
  },
  methods: {
    update(row) {
      //console.log(qty);
    },
    submitForm() {
      ////console.log(this.tableData);
      var vm = this;
      this.ValidateData();
      if (this.validdata) {      
        var url = "SaskHealthApi/Notifications/PostEmailList/";
        var params = {
          _: Date.now(),
          ClinicNo: vm.ClinicNo,
          PharmacyEmailList: this.tableData,
        };
        axios({
          method: "post",
          url: url,
          headers: {
            Authorization: "Bearer " + vm.$store.getters.GetAccessToken,
          },
          data: params,
        })
          .then(function (response) {
            //console.log(response.data);
            vm.showMsg(response.data, "", "Notification Confirmation");
          })
          .catch(function (responseError) {
            if (responseError.status == 500) {
              vm.showMsg(
                "Error while processing your request, please contact system admin.",
                "",
                "Request Confirmation"
              );
            } else if (responseError.status == 400) {
              vm.showMsg(
                "Error while processing your request, please contact system admin.",
                "",
                "Request Confirmation"
              );
            }
          })
          .then(function () {});
      }
    },
    ValidateData() {
      var msg = "";
      var msg_addition = "";
      var vm = this;
      var obj = _.find(this.tableData, function (o) {
        return o.email != "";
      });
      ////console.log(obj)
      if (obj == undefined) {
        this.showMsg("Please enter valid email.", "", "Notification Email");
        ////console.log(obj)
        //alert('no element')
        vm.validdata = false;
      } else {
        _.forEach(this.tableData, function (value) {
          if (value.email != "") {
            if (
              /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value.email)
            ) {
              vm.validdata = true;
              //console.log("valid");
            } else {
              vm.validdata = false;
              //msg = "For " + value.label + " '" + value.email + "'  is not a valid email address. ";
              msg += value.label + " , ";
              // vm.showMsg( msg, "", "Email validation failed.");
              // if( msg != "" ) {
              //   msg = "\n \n" + msg_addition;
              // } else {
              //   msg = msg_addition;
              // }
              //console.log("in-valid");
            }
          }
        });
        if (msg != "") {
          ////console.log(msg.slice(0, -2))
          //vm.validdata = false;
          var newmsg = "Invalid email found: " + msg.slice(0, -2);
          this.showMsg(newmsg, "", "Email validation failed.");
        } else {
          //vm.validdata = true;
        }
      }
    },
    ValidateEmail(email) {
      // if( email === "" ) {
      //   return true; // no email added; validated as an empty slot
      // }
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return false;
      } else {
        return true;
      }
    },
    GetClinicEmails() {
      this.tableData = [];
      var vm = this;
      var params = new URLSearchParams();
      //console.log("clinic no =  " + vm.ClinicNo);
      params.append("clinicno", vm.ClinicNo);
      axios
        .get("SaskHealthApi/Codes/GetPharmacyEmails", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          //console.log(response.data);
          vm.tableData = response.data;
          ////console.log("clinic no " + vm.ClinicNo);
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function () {

          
        });
    },
    GetClinicInfo() {
      var vm = this;
      var params = new URLSearchParams();
      ////console.log("username " + vm.UserName);
      params.append("username", vm.UserName);
      axios
        .get("SaskHealthApi/Codes/GetClinicinfo", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          ////console.log(response.data);
          vm.clinic = response.data;
          vm.ClinicNo = vm.clinic[0].clinicno;
          ////console.log("clinic no " + vm.ClinicNo);
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function () { 
            vm.GetClinicEmails();
        });
    },
    Show() {
      this.Showinfo = true;
    },
    ClosePopup() {
      this.showError = false;
    }, //FHRegisterEDS

    showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
  },

  created: function () {
    this.$emit("update:layout", LayoutDefault);
    this.AppServiceID = this.$store.getters.GetFHServiceID;
    this.dateFormat = this.$store.getters.GetDateFormat;
    this.ServiceDate = moment(new Date()).format("YYYY/MM/DD");
    this.GetClinicInfo();
  },
  beforeCreate: function () {
    this.$store.dispatch("AddServiceID", this.$store.getters.GetFHServiceID);
    this.$store.dispatch("GetMenuItems", this.$store.getters.GetFHServiceID);
  },
  mounted: function () {
    //this.$refs.SearchClinic.inputValue = 'Some value'
    this.$nextTick(function () {});
  },

  validations() {
    return {
      // SelectedClinic : {
      //   required,
      // },
      // selectedProvider : {
      //   required,
      // },
      HSN: {
        required,
        numeric,
        minLength: minLength(9),
      },
      effectiveDate: {
        val: (value) => this.ValidateEffectDate(),
      },
      Risks: {
        val: (value) => this.ValidateRisk(),
      },
      SelectFacId: {
        val: (value) => this.ValidateFacility(),
      },
    };
  },
};
</script>
<style scopped>
.ulClass {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0px !important;
}
.liClass {
  border: 1px solid;
  margin-bottom: 5px;
  border-radius: 5px;
  margin-right: 5px;
  padding: 0 5px;
}
.file-name {
  min-width: 150px;
  font-size: 13px;
}
.uploaded-date {
  font-size: 12px;
}
.upload-progress {
  font-size: 12px;
}
.file-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0px !important;
}
.file-details {
  margin-bottom: 0px !important;
}

.row.no-gutter [class*="col-"] {
  padding-right: 1px;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 0px 15px;
  margin-bottom: -1px;
  border: 1px solid #ddd;
  background-color: blue;
  line-height: 1em;
}
/* remove right padding from first column */
/* .row.no-gutter [class*='col-']:first-child {
  padding-right:5px;
} */
/* remove left padding from first column */
/* .row.no-gutter [class*='col-']:last-child {
  padding-left:5px;
} */

/* only for column content visible */
.col-lg-1 > div {
  background-color: #ddd;
}

#docimg {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 10px; */
}
#line {
  border-top: 1px solid rgba(7, 14, 109, 0.25);
  /* border-bottom:1px solid #c00;
  border-bottom: 1px solid rgba(255,255,255,.25); */
}
.select-css {
  display: block;
  font-size: 14px;
  /* font-family: sans-serif; */
  font-weight: 600;
  color: #444;
  line-height: 1.3;
  padding: 0.6em 1.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  /* appearance: none; */
  background-color: #fff;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}
.select-css::-ms-expand {
  display: none;
}
.select-css:hover {
  border-color: #888;
}
.select-css:focus {
  border-color: #aaa;
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #222;
  outline: none;
}
.select-css option {
  font-weight: normal;
}
#ServiceCodeGrid .VuePagination__count {
  visibility: hidden;
  height: 0px;
}
#ServiceCodeGrid .pagination {
  height: 0px;
}
/* #ServiceCodeGrid tr td:nth-child(2) {
    width: 9.5rem !important;
    padding:3px !important;
    /* margin:0rem !important;
}  */

.highlight {
  background-color: #fff2ac;
  background-image: linear-gradient(to right, #ffe359 0%, #fff2ac 100%);
}
.bd-highlight {
  /* background-color: rgba(86,61,124,0.15); */
  /* border: 1px solid rgba(86,61,124,0.15); */
  background-image: linear-gradient(to right, #ffe359 0%, #fff2ac 100%);
  /* background-image: linear-gradient(to right, #ac9732ad 0%, #cebc5985 100%); */
  /* text-decoration-line: underline; */
  font-weight: bold;
  padding: 0.4rem;
  margin: 0rem !important;
}

.cov {
  font-size: 1.3rem;
  font-weight: bolder;
  /* padding: .2rem; */
  margin: 0rem !important;
}
</style>